import { render, staticRenderFns } from "./portalCard.vue?vue&type=template&id=a82bf668&"
import script from "./portalCard.vue?vue&type=script&lang=js&"
export * from "./portalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports